<template>
    <x-mdl ref="mdl" :label="label">
        <el-form-item :prop="prop" :rules="rules">
            <input ref="input" type="text" class="mdl-textfield__input"
                onClick="this.setSelectionRange(0, this.value.length)"             
                autocomplete="off"
                :value="time" 
                @change="time = $event.target.value"
                /> 
        </el-form-item>
    </x-mdl>
</template>

<script>
// pattern="^([0]?[1-9]|[1|2][0-9]|[3][0|1])/([0]?[1-9]|[1][0-2])/(19|20)\d\d$"
import mdl from '~/mixins/mdl';
export default {
    name: 'XTimepicker',
    mixins : [mdl],
    props:{
        valueFormat : {
            default : 'X'
        },
        timeFormat :{
            default : "HH:mm"
        }
    },
    computed:{
        time:{
             get() {
                const time = moment(this.$data._value, this.valueFormat);
                return this.$data._value && time.isValid() ? time.format(this.timeFormat) : "";
            },
            set(val) {
                const time = moment(val,this.timeFormat);
                const datetime = time.isValid() ? this.date + " " + time.format(this.timeFormat) : this.date + " 00:00"  
                this.$data._value = moment(datetime).format(this.valueFormat)
                this.$emit('input', this.$data._value)
                this.$refs['mdl'].update()
             }
        },
        date(){
            const date = moment(this.$data._value, this.valueFormat);
            return date.isValid() ? date.format("YYYY-MM-DD") : "0000-00-00";
        }
    },
    methods:{
        init(){
               $(this.$refs['input']).timepicker({
                    step: 5,
                    timeFormat: 'H:i'
                })
                .timepicker('setTime', new Date())
                .on('change',(e) =>{
                    this.time = e.target.value
                });

            // $(this.$refs['input']).datepicker({
            //     dateFormat: 'dd/mm/yy',
            //     changeYear: true,
            //     yearRange: "1900:2050",
            //     onSelect : (v) => this.date = v
            // }).on('change',(e) =>{
            //     this.$refs['mdl'].update()
            // });

            //this.$emit('input', this.date)
        }
    }
}
</script>
